import * as React from 'react'

import { ReactComponent as Points } from '@src/assets/navigation/balls.svg'
import { ReactComponent as Purchases } from '@src/assets/navigation/purchases.svg'
import { ReactComponent as Profile } from '@src/assets/navigation/profile.svg'
import { ReactComponent as PasswordChange } from '@src/assets/navigation/password-change.svg'
import { ReactComponent as Coupons } from '@src/assets/navigation/coupons.svg'

type NavigationLinksType = Array<{
  name: string
  icon: React.FunctionComponent<React.SVGProps<
    SVGSVGElement
    > & { title?: string }>
  url: string
}>

export const navigationLinks: NavigationLinksType = [
  {
    name: 'Моя карта',
    icon: Points,
    url: 'points/',
  },
  {
    name: 'Мои покупки',
    icon: Purchases,
    url: 'purchases/',
  },
  {
    name: 'Игровые коды',
    icon: Coupons,
    url: 'coupons/',
  },
  /* {
    name: 'Электронные фишки',
    icon: Chips,
    url: 'chips/',
  }, */
  /* {
    name: 'Любимые группы товаров',
    icon: ProductGroup,
    url: 'product-group/',
  }, */
  {
    name: 'Личные данные',
    icon: Profile,
    url: 'profile/',
  },
  {
    name: 'Смена пароля',
    icon: PasswordChange,
    url: 'password-change/',
  },
]
